import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Jobs from './pages/Careers';
import Faqs from './pages/Faqs';
import PrivacyPolicy from './pages/PrivacyPolicy'; 
import TermsOfSerices from './pages/TermsOfServices'; 
import ServiceDetail from './pages/ServiceDetail';
import { useScrollToTop } from './hooks/useScrollToTop';
import { HelmetProvider, Helmet } from 'react-helmet-async';


const ScrollToTopWrapper = () => {
  useScrollToTop();
  return null;
};
const App = () => {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTopWrapper />
        <Helmet>
          <title>MASA Hills Health Services</title>
          <meta name="google-site-verification" content="-OAVng-veWJGqdJiSOi2Y18xf0pMwFTXGL2tXHFaSMQ" />
          <meta name="viewport" content="width=device-width,initial-scale=1" />
          <link rel="icon" type="image/png" href="/favicon-96x96.png" sizes="96x96" />
          <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
          <link rel="shortcut icon" href="/favicon.ico" />
          <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
          <link rel="manifest" href="/site.webmanifest" />
        </Helmet>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/faqs" element={<Faqs />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path='/terms-of-services' element={<TermsOfSerices />} />
            <Route path="/services/:serviceId" element={<ServiceDetail />} />
          </Route>
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
